interface ITitleProps {
  children: React.ReactNode;
  dataTestId?: string;
}

export const Title: React.FC<ITitleProps> = ({ dataTestId, children }) => {
  return (
    <span
      data-testid={dataTestId}
      className="tw-lf-caption-strong tw-truncate tw-text-center tw-text-blue-600 desktop:tw-text-left"
    >
      {children}
    </span>
  );
};
